import { ICustomBinding } from "#/DefaultViewExtensionInterfaces";

export default class ClassesBinding implements ICustomBinding {

    public initBinding() {
        ko.bindingHandlers.classes = {
            update: (node: HTMLElement, valueAccessor: () => any) => {
                let element = $(node);
                let value = valueAccessor();
                let classes = ko.unwrap(value);

                for (let i = 0; i < classes.length; i++) {
                    element.addClass(classes[i]);
                }
            }
        };
    }
}